module.exports = __webpack_public_path__ + "img/1c-direct.a2d3775d.png";